export interface MetabotUsage {
    spent: number
    limit: number | null
    remaining: number | null
    resetsAt: string | null
}

export type UsageLevel = 'ok' | 'warn' | 'low'

export function usageLevel(remaining: number | null): UsageLevel {
    if (remaining === null) return 'ok'
    if (remaining < 1) return 'low'
    if (remaining < 2) return 'warn'
    return 'ok'
}

const dollars = (n: number) => `$${n.toFixed(2)}`

export function formatUsage(usage: MetabotUsage): string {
    const parts = [usage.limit === null ? `${dollars(usage.spent)} used` : `${dollars(usage.spent)} of ${dollars(usage.limit)} used`]
    if (usage.resetsAt) {
        const date = new Date(usage.resetsAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
        parts.push(`resets ${date}`)
    }
    return parts.join(' · ')
}
